import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { BeneficiaryReportFilter, SenderReportFilter } from './report.types';

/** Sender / beneficiary reporting endpoints. The response schema is not
 * documented, so callers treat the payload as an opaque row list for export. */
@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private httpClient: HttpClientService) {}

  senderReport(
    payload: SenderReportFilter
  ): Observable<ResponseIdentity<unknown[]>> {
    return this.httpClient.post(
      API_URL_CONSTANT.reports.senderReport,
      removeEmptyStrings(payload)
    );
  }

  beneficiaryReport(
    payload: BeneficiaryReportFilter
  ): Observable<ResponseIdentity<unknown[]>> {
    return this.httpClient.post(
      API_URL_CONSTANT.reports.beneficiaryReport,
      removeEmptyStrings(payload)
    );
  }
}
